import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from 'src/shared/material/material.module';
import { CommonModule } from '@angular/common';
import { BillingDetailsComponent } from './billing-details.component';
import { SharedGlobalModule } from 'src/shared/shared-global.module';
import { FormModelsModule } from 'src/shared/form-models/form-models.module';
import {
	BillingCompanyComponent,
	ReadonlyBillingCompanyComponent,
} from './billing-company/billing-company.component';
import { CommonUiModule } from '../common-ui/common-ui.module';
import { MultiChipInputModule } from '../multi-chip-input/multi-chip-input.module';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MaterialModule,
		FlexLayoutModule,
		FormModelsModule,
		SharedGlobalModule,
		CommonUiModule,
		MultiChipInputModule,
	],
	declarations: [
		BillingDetailsComponent,
		BillingCompanyComponent,
		ReadonlyBillingCompanyComponent,
	],
	exports: [BillingDetailsComponent],
})
export class BillingDetailsModule {}
